<template>
  <div class="searchProduct-page">
     <QyList
        v-if="QyListData.length"
        :typeName="currTypeData"
        @getNewData="getData"
        :total="currTypeTotal"
        :listData="QyListData"
      ></QyList>
    <div v-else class="nodata">没查找到数据~</div>
  </div>
</template>

<script>
import {
  defineComponent,
  createApp,
  computed,
  reactive,
  ref,
  onMounted,
  toRefs,
} from "vue";
import { useStore } from "vuex";
import QyList from "@/components/QyList.vue";
// import { Tab, Tabs, DropdownMenu, DropdownItem, Button, Cell } from "vant";
import { useRoute, useRouter } from "vue-router";
import UserService from "@/api/common.js";

export default defineComponent({
  components: {
    QyList,
  },
  props: {},
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const searchTxt = route.query.q;
    const uid = localStorage.uid;
    const QyListData = ref([]);

    const pageInfo = reactive({
      pagesize: 10,
      startRow: 0,
      totalPage: 1,
      curr: 0,
    });

    onMounted(() => {
      initInfo()
    });

    const initInfo = async () => {
      const postData = {
        search: searchTxt,
        uid,
        pagesize: pageInfo.pagesize,
        startRow: pageInfo.curr * pageInfo.pagesize,
      };
      const data = await UserService.searchProduct(postData);
      console.log(data); if (!data) return;
      const { productList, total } = data;

      if (productList)
        QyListData.value = [...QyListData.value, ...productList];
      pageInfo.totalPage = Math.ceil(total / pageInfo.pagesize);
    };

    const getData = async () => {
      pageInfo.curr += 1;
      if (pageInfo.curr > pageInfo.totalPage || pageInfo.totalPage === 1) return;
      initInfo();
    };


    return {
     ...toRefs(pageInfo),
      QyListData,
      getData,
    };
  },
});
</script>
<style lang="scss">
.searchProduct-page {
  min-height: 100vh;
  background: #f8f8f8;
 
 
  .list-box {
    .list-wrap {
      padding: 0.2rem 0.3rem;
    }
  }
  .nodata{
          padding-top: 1rem;
      text-align: center;
      @include fontSC(0.3rem, #666);
  }
}
</style>
